import { useState } from "react";
import { Col, Form, Row, Table } from "react-bootstrap";
import StreamingPDFButton from "./StreamingPDFButton";

function DamageRequest() {
  const [errorsCompensationReq, setErrorsCompensationReq] = useState({});
  const [formCompensationReq, setFormCompensationReq] = useState({});
  const [image1Compensation, setImage1Compensation] = useState(null);
  const [image2Compensation, setImage2Compensation] = useState(null);
  const [image3Compensation, setImage3Compensation] = useState(null);
  const [image4Compensation, setImage4Compensation] = useState(null);
  const [imageIdentityCompensation, setImageIdentityCompensation] =
    useState(null);

  const handleCompensationRequest = e => {
    e.preventDefault();
    const newErrors = findErrorCompensationReq();
    if (Object.keys(newErrors).length > 0) {
      setErrorsCompensationReq(newErrors);
    } else {
      compensationRequest();
    }
  };

  const setImageCompensationReq = (field, value) => {
    if (field === "image1Compensation") {
      setImage1Compensation(URL.createObjectURL(value));
    }
    if (field === "image2Compensation") {
      setImage2Compensation(URL.createObjectURL(value));
    }
    if (field === "image3Compensation") {
      setImage3Compensation(URL.createObjectURL(value));
    }
    if (field === "image4Compensation") {
      setImage4Compensation(URL.createObjectURL(value));
    }
    if (field === "imageIdentityCompensation") {
      setImageIdentityCompensation(URL.createObjectURL(value));
    }
    if (errorsCompensationReq[field])
      setErrorsCompensationReq({ ...errorsCompensationReq, [field]: null });
  };

  const compensationRequest = async () => {
    const formData = new FormData();
    formData.append("numberParcel", formCompensationReq.traceCodeCompensation);
    formData.append("typeShipment", formCompensationReq.typeCompensation);
    formData.append("Shipment", formCompensationReq.productNameCompensation);
    formData.append("price", formCompensationReq.priceCompensation);
    formData.append("brandName", formCompensationReq.brandCompensation);
    formData.append("shabaNumber", formCompensationReq.shabaNumberCompensation);
    formData.append("description", formCompensationReq.descCompensation);
    formData.append("image1", image1Compensation);
    formData.append("image2", image2Compensation);
    formData.append("image3", image3Compensation);
    formData.append("image4", image4Compensation);
    formData.append("cardImage", imageIdentityCompensation);

    // const response = await postMethod('/myaccount/v1/damage/add', formData)
    // try {
    //   const response = await axios({
    //     method: "post",
    //     url: baseUrl + "/myaccount/v1/damage/add",
    //     data: formData,
    //     headers: {
    //       "Content-Type": "multipart/form-data",
    //       Authorization: "Bearer " + token,
    //     },
    //   });
    // } catch (error) {
    //   error;
    // }
  };

  const findErrorCompensationReq = () => {
    const {
      traceCodeCompensation,
      typeCompensation,
      productNameCompensation,
      priceCompensation,
      brandCompensation,
      shabaNumberCompensation,
      descCompensation,
    } = formCompensationReq;

    const newErrors = {};
    if (!traceCodeCompensation || traceCodeCompensation === "") {
      newErrors.traceCodeCompensation = "کدپیگیری الزامیست";
    }
    if (!typeCompensation || typeCompensation === "") {
      newErrors.typeCompensation = "نوع کالا الزامیست";
    }
    if (!productNameCompensation || productNameCompensation === "") {
      newErrors.productNameCompensation = "نام کالا الزامیست";
    }
    if (!priceCompensation || priceCompensation === "") {
      newErrors.priceCompensation = "قیمت الزامیست";
    }
    if (!brandCompensation || brandCompensation === "") {
      newErrors.brandCompensation = "مدل الزامیست";
    }
    if (!shabaNumberCompensation || shabaNumberCompensation === "") {
      newErrors.shabaNumberCompensation = "شماره شبا الزامیست";
    }
    if (!descCompensation || descCompensation === "") {
      newErrors.descCompensation = "شرح درخواست الزامیست";
    }
    if (!image1Compensation || image1Compensation === "") {
      newErrors.image1Compensation = "تصویر کالا الزامیست";
    }
    if (!image2Compensation || image2Compensation === "") {
      newErrors.image2Compensation = "تصویر کالا الزامیست";
    }
    if (!image3Compensation || image3Compensation === "") {
      newErrors.image3Compensation = "تصویر کالا الزامیست";
    }
    if (!image4Compensation || image4Compensation === "") {
      newErrors.image4Compensation = "تصویر کالا الزامیست";
    }
    if (!imageIdentityCompensation || imageIdentityCompensation === "") {
      newErrors.imageIdentityCompensation = "تصویر کارت ملی الزامیست";
    }

    return newErrors;
  };

  const setFieldCompensationReq = (field, value) => {
    setFormCompensationReq({ ...formCompensationReq, [field]: value });
    if (errorsCompensationReq[field])
      setErrorsCompensationReq({ ...errorsCompensationReq, [field]: null });
  };

  return (
    <div>
      <h4 className="text-secondary">لیست درخواست های خسارت</h4>
      <hr />
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th>عنوان</th>
            <th width="150">وضعیت</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>درخواست خسارت 1</td>
            <td>پاسخ داده شده</td>
          </tr>
          <tr>
            <td>2</td>
            <td>درخواست خسارت 2</td>
            <td>در حال بررسی</td>
          </tr>
          <tr>
            <td>3</td>
            <td>درخواست خسارت 3</td>
            <td>در حال بررسی</td>
          </tr>
        </tbody>
      </Table>
      <h4 className="text-secondary mt-5">ثبت درخواست خسارت</h4>
      <hr />
      <Form onSubmit={handleCompensationRequest}>
        <Row className="mt-2">
          <Col lg={6} md={6} sm={12}>
            <Form.Group>
              <Form.Label>
                کد پیگیری<span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="traceCodeCompensation"
                onChange={e =>
                  setFieldCompensationReq(
                    "traceCodeCompensation",
                    e.target.value
                  )
                }
                isInvalid={!!errorsCompensationReq.traceCodeCompensation}
              />
              <Form.Control.Feedback type="invalid">
                {errorsCompensationReq.traceCodeCompensation}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col lg={6} md={6} sm={12}>
            <Form.Group>
              <Form.Label>
                نوع کالا<span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                type="text"
                name="typeCompensation"
                onChange={e =>
                  setFieldCompensationReq("typeCompensation", e.target.value)
                }
                isInvalid={!!errorsCompensationReq.typeCompensation}
              >
                <option selected disabled>
                  ...
                </option>
                <option value="نو">نو</option>
                <option value="دست دو">دست دو</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errorsCompensationReq.typeCompensation}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>
        <Row className="mt-2">
          <Col lg={6} md={6} sm={12}>
            <Form.Group>
              <Form.Label>
                نام کالا<span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="productNameCompensation"
                onChange={e =>
                  setFieldCompensationReq(
                    "productNameCompensation",
                    e.target.value
                  )
                }
                isInvalid={!!errorsCompensationReq.productNameCompensation}
              />
              <Form.Control.Feedback type="invalid">
                {errorsCompensationReq.productNameCompensation}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col lg={6} md={6} sm={12}>
            <Form.Group>
              <Form.Label>
                قیمت خرید<span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="priceCompensation"
                onChange={e =>
                  setFieldCompensationReq("priceCompensation", e.target.value)
                }
                isInvalid={!!errorsCompensationReq.priceCompensation}
              />
              <Form.Control.Feedback type="invalid">
                {errorsCompensationReq.priceCompensation}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>
        <Row className="mt-2">
          <Col lg={6} md={6} sm={12}>
            <Form.Group>
              <Form.Label>
                نام برند کالا
                <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="brandCompensation"
                onChange={e =>
                  setFieldCompensationReq("brandCompensation", e.target.value)
                }
                isInvalid={!!errorsCompensationReq.brandCompensation}
              />
              <Form.Control.Feedback type="invalid">
                {errorsCompensationReq.brandCompensation}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col lg={6} md={6} sm={12}>
            <Form.Group>
              <Form.Label>
                شماره شبا<span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="shabaNumberCompensation"
                onChange={e =>
                  setFieldCompensationReq(
                    "shabaNumberCompensation",
                    e.target.value
                  )
                }
                isInvalid={!!errorsCompensationReq.shabaNumberCompensation}
              />
              <Form.Control.Feedback type="invalid">
                {errorsCompensationReq.shabaNumberCompensation}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>
        <Col lg={12} md={12} sm={12}>
          <Form.Group>
            <Form.Label>توضیحات</Form.Label>
            <Form.Control
              as="textarea"
              name="descCompensation"
              className="form-control"
              onChange={e =>
                setFieldCompensationReq("descCompensation", e.target.value)
              }
              isInvalid={!!errorsCompensationReq.descCompensation}
            />
            <Form.Control.Feedback type="invalid">
              {errorsCompensationReq.descCompensation}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Row className="mt-2">
          <Col>
            <Form.Group>
              <Form.Label>
                تصویر یک<span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="file"
                name="image1Compensation"
                onChange={e => {
                  setImageCompensationReq(
                    "image1Compensation",
                    e.target.files[0]
                  );
                }}
                isInvalid={!!errorsCompensationReq.image1Compensation}
              />
              <Form.Control.Feedback type="invalid">
                {errorsCompensationReq.image1Compensation}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <Form.Label>
                تصویر دو<span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="file"
                name="image2Compensation"
                onChange={e =>
                  setImageCompensationReq(
                    "image2Compensation",
                    e.target.files[0]
                  )
                }
                isInvalid={!!errorsCompensationReq.image2Compensation}
              />
              <Form.Control.Feedback type="invalid">
                {errorsCompensationReq.image2Compensation}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Group>
              <Form.Label>
                تصویر سه<span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="file"
                name="image3Compensation"
                onChange={e =>
                  setImageCompensationReq(
                    "image3Compensation",
                    e.target.files[0]
                  )
                }
                isInvalid={!!errorsCompensationReq.image3Compensation}
              />
              <Form.Control.Feedback type="invalid">
                {errorsCompensationReq.image3Compensation}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <Form.Label>
                تصویر چهار<span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="file"
                name="image4Compensation"
                onChange={e =>
                  setImageCompensationReq(
                    "image4Compensation",
                    e.target.files[0]
                  )
                }
                isInvalid={!!errorsCompensationReq.image4Compensation}
              />
              <Form.Control.Feedback type="invalid">
                {errorsCompensationReq.image4Compensation}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col lg={6} md={6} sm={6}>
            <Form.Group>
              <Form.Label>
                تصویر کارت ملی
                <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="file"
                name="imageIdentityCompensation"
                onChange={event =>
                  setImageCompensationReq(
                    "imageIdentityCompensation",
                    event.currentTarget.files[0]
                  )
                }
                isInvalid={!!errorsCompensationReq.imageIdentityCompensation}
              />
              <Form.Control.Feedback type="invalid">
                {errorsCompensationReq.imageIdentityCompensation}
              </Form.Control.Feedback>
            </Form.Group>
            <img src={imageIdentityCompensation} />
          </Col>
        </Row>
        <div className="d-flex align-items-center justify-content-center my-4">
          <button type="submit" className="btn-success-style text-white">
            ارسال
          </button>
        </div>
      </Form>

      <StreamingPDFButton />
    </div>
  );
}

export default DamageRequest;
